import { getOrderPassengerPoints } from "../../../../../../../redux/constants/OrdersPage/order";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model): string | undefined => {
	const points = getOrderPassengerPoints(item);
	return points.at(-1)?.settlement ?? "";
};

export default cellProcessing;
